module.exports = __webpack_public_path__ + "img/mercedes-tech-logo.799e78f1.jpg";